module.exports = __webpack_public_path__ + "static/media/fromTheHelpDesk.a0353335.m4a";